/** Celdas solo numéricas largas: Excel las abre como número y muestra 7,79E+12. */

const LONG_DIGITS_ONLY = /^\d{8,}$/;

export function shouldForceExcelTextInCsv(value: string): boolean {
  return LONG_DIGITS_ONLY.test(String(value ?? '').trim());
}

/** Prefijo TAB: Excel interpreta la celda como texto al abrir el CSV. */
export function forceExcelTextCsvCell(value: string): string {
  const trimmed = String(value ?? '').trim();
  if (!shouldForceExcelTextInCsv(trimmed)) return String(value ?? '');
  return `\t${trimmed}`;
}

/**
 * Corrige valores que Excel guardó en notación científica (p. ej. 7,79E+12).
 * Devuelve el texto original si no parece notación científica.
 */
export function normalizeCsvNumericFieldFromExcel(raw: string): string {
  const trimmed = raw.trim();
  if (!trimmed) return trimmed;
  if (!/[eE]/.test(trimmed)) return trimmed;

  const compact = trimmed.replace(/\s/g, '');
  if (!/^[\d.,]+[eE][+-]?\d+$/i.test(compact)) return trimmed;

  const normalized = compact.replace(',', '.');
  const n = Number(normalized);
  if (!Number.isFinite(n) || n < 0) return trimmed;

  return String(Math.round(n));
}
